export var ROLELISTING_EVENT;
(function (ROLELISTING_EVENT) {
    ROLELISTING_EVENT["REFRESH"] = "RoleEvent.Refresh";
})(ROLELISTING_EVENT || (ROLELISTING_EVENT = {}));
export var HIDDEN_ROLES = ["super_admin"];
